import React from 'react';

import PageTemplate from '../components/templates/PageTemplate';
import OrganizationsView from '../components/organisms/OrganizationsView';

const OrganizationsContainer = () => {
  return (
    <PageTemplate>
      {/* ph-no-capture: exclude org/user PII in this view from PostHog autocapture */}
      <div className="ph-no-capture">
        <OrganizationsView />
      </div>
    </PageTemplate>
  );
};

export default OrganizationsContainer;
